import AssignmentCard from './AssignmentCard';

export default AssignmentCard;
